import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=86ab97fe"
import script from "./PhoneInput.ts?vue&type=script&lang=ts&external"
export * from "./PhoneInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports